// MFA-Pflicht: Kunde (M23-Ausschnitt, auf der Benutzerseite) und Plattform (P04-Ausschnitt). DQ-SEC-041.
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ak, serverMessage, usePlatformSecurity, useTenantMfaPolicy, type MfaPolicy } from '../../api/account';
import { api } from '../../api/client';
import { Icon } from '../../components/Icon';
import { useToast } from '../../components/toast';
import '../../styles/account.css';

export function TenantMfaPolicyCard() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const toast = useToast();
  const { data: policy } = useTenantMfaPolicy();
  const [error, setError] = useState('');
  if (!policy) return null;
  const change = async (next: MfaPolicy) => {
    setError('');
    try {
      await api.put('/tenant/mfa-policy', { requiredFor: next });
      await qc.invalidateQueries({ queryKey: ak.tenantPolicy });
      await qc.invalidateQueries({ queryKey: ['users'] });
      toast.show(t('common.saved'));
    } catch (e) {
      setError(serverMessage(e) ?? t('errors.network'));
    }
  };
  return (
    <section className="card col" style={{ marginTop: 16 }} aria-labelledby="mfa-policy">
      <h2 id="mfa-policy" className="card-title"><Icon name="shield" />{t('account.policy.title')}</h2>
      <div className="muted small">{t('account.policy.text')}</div>
      <div className="seg" role="radiogroup" aria-label={t('account.policy.title')} style={{ justifySelf: 'start' }}>
        {(['none', 'admins', 'all'] as const).map((p) => (
          <button key={p} type="button" role="radio" aria-checked={policy === p} className={policy === p ? 'on' : ''} onClick={() => void change(p)}>{t(`account.policy.${p}`)}</button>
        ))}
      </div>
      {error && <div className="error" role="alert">{error}</div>}
    </section>
  );
}

export function PlatformSecurityCard() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const toast = useToast();
  const { data } = usePlatformSecurity();
  const [error, setError] = useState('');
  if (!data) return null;
  const change = async (on: boolean) => {
    setError('');
    try {
      await api.put('/platform/security', { mfaPlatformAdmins: on });
      await qc.invalidateQueries({ queryKey: ak.platformSecurity });
      toast.show(t('common.saved'));
    } catch (e) {
      setError(serverMessage(e) ?? t('errors.network'));
    }
  };
  return (
    <div className="card col" aria-labelledby="plat-sec">
      <h2 id="plat-sec" className="card-title"><Icon name="shield" />{t('account.policy.platformTitle')}</h2>
      <label className="check"><input type="checkbox" checked={data.mfaPlatformAdmins} onChange={(e) => void change(e.target.checked)} />{t('account.policy.platformAdmins')}</label>
      <div className="muted small">{t('account.policy.platformText')}</div>
      {error && <div className="error" role="alert">{error}</div>}
    </div>
  );
}
